// Vendor Imports
import React from 'react';

export interface FilterHeaderProps {
  children?: React.ReactNode;
  name: string;
}

export default function FilterHeader({ children, name }: FilterHeaderProps) {
  return (
    <div className="filter-control-title">
      <h3>{name}</h3>
      {children}
    </div>
  );
}
